<template>
  <div>
    <table
      v-intersect.once
      class="my-release-list__table"
      @intersect="onIntersect">
      <thead class="my-release-list__thead">
        <tr>
          <th class="link-list__cell-jacket">作品タイトル</th>
          <th class="link-list__cell-genre">スプリット申請日</th>
          <th class="link-list__cell-genre">管理者</th>
          <th class="link-list__cell-artist">分配率</th>
          <th class="link-list__cell-title">ステータス</th>
        </tr>
      </thead>
      <tbody
        v-if="pagination.data && pagination.data.length > 0"
        class="link-list__tbody">
        <tr
          v-for="item in pagination.data"
          :key="item.id">
          <td>{{ item.copyrights.title_ja }}</td>
          <td>{{ reformatDateTime(item.updated_at) }}</td>
          <td>{{ item.owner_email }}</td>
          <td>{{ formattedRate(item.rate) }}%</td>
          <td>{{ getStatusText(item.status) }}</td>
        </tr>
      </tbody>
      <tbody
        v-else-if="loading"
        class="link-list__tbody">
        <tr>
          <td
            class="empty-cell vld-parent"
            :class="{ 'disabled-cell': loading }"
            :colspan="numberOfColumns">
            <div
              class="vld-cell">
              <div class="vld-loading-icon">
                <vue-loading
                  background-color="#fff"
                  :opacity="0"
                  :active="true"
                  :height="20"
                  :width="20"
                  :is-full-page="false">
                </vue-loading>
              </div>
              <div class="vld-text">
                読み込み中
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody
        v-else-if="!loading"
        class="link-list__tbody">
        <tr>
          <td
            class="empty-cell"
            :colspan="numberOfColumns">
            <slot name="empty" />
          </td>
        </tr>
      </tbody>
    </table>
    <pagination
      :pagination="pagination"
      @on-pagination-clicked="onPaginationClicked">
    </pagination>
  </div>
</template>

<script>

import VueLoading from 'vue-loading-overlay'
import Pagination from '../../../../components/Pagination'

export default {
  name: 'SplitGuestTable',
  components: {
    Pagination,
    VueLoading,
  },
  filters: {
    toJapanese: (value) => (value === 'single' ? 'シングル' : 'アルバム'),
  },
  props: {
    status: {
      type: [Number, String, Array],
      required: true,
    },
    hideControl1: {
      type: Boolean,
      default: false,
    },
    keyword: {
      type: [Number, String],
      default: '',
    },
    owner: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      pagination: {},
      timer: null,
      isOwner: this.owner,
    }
  },
  computed: {
    numberOfColumns() {
      let totalColumns = 5
      if (this.hideControl1) {
        totalColumns -= 1
      }
      return totalColumns
    },
  },
  watch: {
    owner(newValue) {
      this.isOwner = newValue
    },
    keyword() {
      this.fetchItems(0)
    },
  },
  async mounted() {
    await this.fetchItems(0)
  },
  methods: {
    reformatDateTime(value) {
      const [dateAndHrs, minutes] = value.split(':')
      return `${dateAndHrs}:${minutes}`
    },
    onIntersect() {
      this.fetchItems()
    },
    async fetchItems(page) {
      this.loading = true
      this.pagination = { data: [] }
      const headers = { 'content-type': 'multipart/form-data', 'X-CMAP-No-Loading': true }
      const { data } = await window.axios.get('/api/client/copyright-splits-as-guest', {
        params: {
          count: 10,
          status: this.status,
          owner: this.isOwner,
          page,
          keyword: this.keyword,
        },
        headers,
      })
      this.pagination = data
      this.loading = false
    },
    onPaginationClicked(page) {
      this.fetchItems(page)
      this.$emit('on-pagination-clicked', page)
    },
    getStatusText(status) {
      let statusText = '承認待ち'
      if (status === 3) {
        statusText = '完了'
      }
      if (status === 4) {
        statusText = 'キャンセル'
      }

      return statusText
    },
    formattedRate(rate) {
      if (!rate) return ''

      return rate !== 100 ? parseFloat(rate).toFixed(1) : '100'
    },
  },
}
</script>

<style scoped>
.empty-cell {
  text-align: center;
  color: #505050;
  padding-top: 5vmin;
  padding-bottom: 5vmin;
}
.wrap-text {
  white-space: pre-line;
  word-break: break-all;
}
.vld-overlay {
  position: relative!important;
}
.vld-cell {
  display: flex;
  justify-content: center;
}
.vld-loading-icon {
  display:inline-flex;
}
.vld-text {
  display:inline-flex;
  padding-left: 10px;
}
.disabled-cell {
  background-color: #F9F6F6;
}

.my-release-list__thead {
  border-bottom: 2px solid #e8e8e8;
}

.my-release-list__thead th {
  background-color: white;
  text-align: center;
}

@media screen and (min-width: 896px) {
  .my-release-list__thead th {
    border: none;
    font-size: 1.4rem;
    padding: 15px;
  }
}

@media screen and (max-width: 895px) {
  .my-release-list__thead th {
    border: none;
    padding: 2.66667vw;
    white-space: nowrap;
  }
}

.link-list__tbody td {
    border: none;
}

.link-list__cell-genre {
  width: 150px;
}

</style>
